/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/unsubscribeMontly.scss';

import {AwesomeIcon, Loader, navigate, ResponseData} from '@dvrd/dvr-controls';
import React, {useEffect, useState} from 'react';
import {Navigate, useParams} from 'react-router';
import {unsubscribeMonthlyMail} from "../../../util/requestSender";
import classNames from 'classnames';
import Image from "../../misc/image";
import {LOGIN_ROUTE} from "../../../util/constants";

export default function UnsubscribeMonthly() {
    const [loading, setLoading] = useState(true);
    const [success, setSuccess] = useState(false);
    const {userId} = useParams<{ userId: string }>();
    if (!userId) return <Navigate to={LOGIN_ROUTE}/>

    function unsubscribe() {
        if (!userId) return navigate(LOGIN_ROUTE);
        unsubscribeMonthlyMail({
            id: userId, callback: (data: ResponseData) => {
                setLoading(false);
                setSuccess(!!data.success);
            }
        });
    }

    function renderHeader() {
        return (
            <div className='header-container'>
                <a href='https://bolmate.nl'>
                    <Image name='logo' className='logo'/>
                </a>
            </div>
        )
    }

    function renderBody() {
        const resultIcon = success ? 'check-circle' : 'circle-xmark';
        const resultLabel = success ? 'Je bent succesvol uitgeschreven van de maandelijkse e-mail.' :
            'Het uitschrijven van de maandelijkse e-mail is niet gelukt.';
        return (
            <div className='body-container'>
                <div className='title-container'>
                    <h2 className='body-title'>Uitschrijven van maandelijkse e-mail</h2>
                </div>
                {loading ? (
                    <div className='loading-container'>
                        <Loader active position='relative' disableBackground/>
                        <label className='loading-label'>Je wordt uitgeschreven van de maandelijkse e-mail...</label>
                    </div>
                ) : (
                    <div className='result-container'>
                        <AwesomeIcon name={resultIcon}
                                     className={classNames('result-icon', success ? 'success' : 'error')}/>
                        <label className='result-label'>{resultLabel}</label>
                    </div>
                )}
            </div>
        )
    }

    useEffect(() => {
        unsubscribe();
    }, []);

    return (
        <div className='unsubscribe-monthly'>
            {renderHeader()}
            {renderBody()}
        </div>
    )
}